import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.scss';

export default class Button extends Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    isBlock: PropTypes.bool,
    isLarge: PropTypes.bool,
    isPrimary: PropTypes.bool,
    isSecondary: PropTypes.bool,
    isTertiary: PropTypes.bool,
    isInverted: PropTypes.bool,
    isGhost: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    type: 'button',
  };

  render() {
    const {
      id,
      className,
      children,
      isBlock,
      isLarge,
      isPrimary,
      isSecondary,
      isTertiary,
      isInverted,
      isGhost,
      isDisabled,
      isLoading,
      onClick,
      type,
    } = this.props;

    return (
      <button
        id={id}
        type={type}
        onClick={onClick}
        className={classNames(styles.button, className, {
          [styles.large]: isLarge,
          [styles.block]: isBlock,
          [styles.primary]: isPrimary,
          [styles.secondary]: isSecondary,
          [styles.tertiary]: isTertiary,
          [styles.inverted]: isInverted,
          [styles.primaryGhost]: isPrimary && isGhost,
          [styles.secondaryGhost]: isSecondary && isGhost,
          [styles.tertiaryGhost]: isTertiary && isGhost,
          [styles.invertedGhost]: isInverted && isGhost,
        })}
        disabled={isDisabled}
      >
        {isLoading ? <i className="fa fa-loading fa-spin" /> : null}
        {children}
      </button>
    );
  }
}
